import { render, staticRenderFns } from "./PaginatedTables.vue?vue&type=template&id=474df948&scoped=true&"
import script from "./PaginatedTables.vue?vue&type=script&lang=js&"
export * from "./PaginatedTables.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTables.vue?vue&type=style&index=0&id=474df948&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474df948",
  null
  
)

export default component.exports